/**
 * Size calculation utilities
 */

export function getMb(limit: number, lastMb: number): boolean {
  return lastMb > limit;
}

export function datasize(data: any): number {
  if (!data) return 0;

  let size: number;

  if (typeof data === 'string') {
    size = new Blob([data]).size;
  } else if (data instanceof Uint8Array || data instanceof ArrayBuffer) {
    size = data.byteLength;
  } else if (Array.isArray(data) || typeof data === 'object') {
    size = new Blob([JSON.stringify(data)]).size;
  } else {
    size = new Blob([String(data)]).size;
  }

  return size / 1000;
}

export function getJsonSizeInMb(jsonDict: any): number {
  if (!jsonDict) return 0;

  const jsonStr = JSON.stringify(jsonDict);
  if (!jsonStr) return 0;

  const sizeInBytes = new Blob([jsonStr]).size;
  const sizeInMb = sizeInBytes / (1024 * 1024);
  
  return sizeInMb;
}
